document.body.addEventListener("click", (event) => {
    const btn = event.target.closest(".quick-filter-btn, .product-type-filter-btn");
    if (!btn) return;
    if (btn.disabled) return;

    const param = btn.dataset.param;
    const value = btn.dataset.value;
    const isResetButton = btn.dataset.reset === "true";
    const isSingleChoice = btn.dataset.singleChoice === "true" || btn.closest('[data-single-choice="true"]');
    const escapeCss = (raw) => (window.CSS && typeof window.CSS.escape === "function" ? window.CSS.escape(raw) : raw);
    const facetsForm = document.querySelector('facets-form');
    if (!facetsForm || !param) return;

    const allInputs = facetsForm.querySelectorAll(`input[name="${escapeCss(param)}"]`);
    if (!allInputs.length) return;

    if (isResetButton) {
        allInputs.forEach((input) => {
            if (input.type === "checkbox" || input.type === "radio") {
                input.checked = false;
            }
        });
    } else {
        const input = facetsForm.querySelector(`input[name="${escapeCss(param)}"][value="${escapeCss(value)}"]`);
        if (!input) return;

        if (isSingleChoice) {
            allInputs.forEach((otherInput) => {
                if (otherInput !== input && (otherInput.type === "checkbox" || otherInput.type === "radio")) {
                    otherInput.checked = false;
                }
            });
            input.checked = true;
        } else {
            const isActive = btn.dataset.active === 'true';
            input.checked = !isActive;
        }
    }

    const submitsOnChange = facetsForm.hasAttribute("update-on-change");

    facetsForm.dispatchEvent(new CustomEvent("change", {
        bubbles: true,
        detail: {
            skipPrefetch: !submitsOnChange
        }
    }));

    if (submitsOnChange) return;

    if (HTMLFormElement.prototype.requestSubmit) {
        facetsForm.querySelector("form").requestSubmit();
    } else {
        facetsForm.querySelector("form").dispatchEvent(new Event("submit", { bubbles: true }));
    }
});

function updateQuickFilterAvailability(root = document) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const facetsForm = scope.querySelector('facets-form') || document.querySelector('facets-form');
    if (!facetsForm) return;

    const quickFilterButtons = scope.querySelectorAll('.quick-filters .quick-filter-btn[data-param][data-value]');
    if (!quickFilterButtons.length) return;

    const escapeCss = (raw) => (window.CSS && typeof window.CSS.escape === "function" ? window.CSS.escape(raw) : raw);

    quickFilterButtons.forEach((btn) => {
        const param = btn.dataset.param;
        const value = btn.dataset.value;
        if (!param || value === undefined) return;

        const input = facetsForm.querySelector(`input[name="${escapeCss(param)}"][value="${escapeCss(value)}"]`);
        if (!input) return;

        const shouldDisable = Boolean(input.disabled);
        btn.disabled = shouldDisable;
        btn.classList.toggle('is-disabled', shouldDisable);
    });
}

const productTypeButtonAvailabilityCache = new Map();

async function fetchProduktartAvailability(param, value, sectionId) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.delete('page');
    params.delete(param);
    params.append(param, value);
    params.set('section_id', sectionId);

    const cacheKey = `${url.pathname}?${params.toString()}`;
    if (productTypeButtonAvailabilityCache.has(cacheKey)) {
        return productTypeButtonAvailabilityCache.get(cacheKey);
    }

    try {
        const response = await fetch(cacheKey, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'text/html'
            }
        });
        if (!response.ok) return true;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const hasResults = doc.querySelectorAll('.collection__results .product-card').length > 0;
        productTypeButtonAvailabilityCache.set(cacheKey, hasResults);
        return hasResults;
    } catch (error) {
        return true;
    }
}

async function updateProductTypeFilterAvailability(root = document) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const bar = scope.querySelector('.product-type-filter-bar__inner') || document.querySelector('.product-type-filter-bar__inner');
    if (!bar) return;

    const facetsForm = document.querySelector('facets-form');
    const sectionId = facetsForm?.getAttribute('section-id');
    if (!sectionId) return;

    const optionButtons = Array.from(bar.querySelectorAll('.product-type-filter-btn[data-param][data-value]'));
    if (!optionButtons.length) return;

    await Promise.all(optionButtons.map(async (btn) => {
        const param = btn.dataset.param;
        const value = btn.dataset.value;
        if (!param || !value) return;

        const hasResults = await fetchProduktartAvailability(param, value, sectionId);
        btn.hidden = !hasResults;
    }));

    const visibleOptions = optionButtons.filter((btn) => btn.hidden !== true);
    const resetButton = bar.querySelector('.product-type-filter-btn[data-reset="true"]');

    if (resetButton) {
        resetButton.hidden = visibleOptions.length === 0;
    }

    const wrapper = bar.closest('.product-type-filter-bar');
    if (wrapper) {
        wrapper.hidden = visibleOptions.length === 0;
    }
}

function toggleCollectionFilterLoading(isLoading) {
    document.body.classList.toggle('collection-filters-loading', Boolean(isLoading));
}

document.documentElement.addEventListener('theme:loading:start', () => {
    toggleCollectionFilterLoading(true);
});

document.documentElement.addEventListener('theme:loading:end', () => {
    toggleCollectionFilterLoading(false);
});



const STICKY_ACTIVATE_Y = 50;

function handleScroll() {
    const header = document.querySelector('.collection-toolbar-wrapper.sticky');
    if (!header) return;

    const currentScroll = Math.max(0, window.scrollY || 0);

    if (currentScroll > STICKY_ACTIVATE_Y) {
        header.classList.add('sticky-active');
    } else {
        header.classList.remove('sticky-active');
    }

    // Legacy safety: ensure old hide class from previous logic doesn't persist.
    header.classList.remove('hide-filters');
}

let ticking = false;
window.addEventListener('scroll', () => {
    if (!ticking) {
        requestAnimationFrame(() => {
            handleScroll();
            ticking = false;
        });
        ticking = true;
    }
}, { passive: true });

window.addEventListener('load', handleScroll);

function updateProductTypeFilterBarAlignment(root = document) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const bars = scope.querySelectorAll('.product-type-filter-bar__inner');
    if (!bars.length) return;

    bars.forEach((bar) => {
        const hasOverflow = (bar.scrollWidth - bar.clientWidth) > 1;
        bar.classList.toggle('is-overflowing', hasOverflow);
    });
}

window.addEventListener('load', () => updateProductTypeFilterBarAlignment(document));
window.addEventListener('load', () => updateQuickFilterAvailability(document));
window.addEventListener('load', () => {
    updateProductTypeFilterAvailability(document);
});

let productTypeBarResizeTimer;
window.addEventListener('resize', () => {
    clearTimeout(productTypeBarResizeTimer);
    productTypeBarResizeTimer = setTimeout(() => {
        updateProductTypeFilterBarAlignment(document);
    }, 120);
}, { passive: true });

document.addEventListener('facet:updated', () => {
    productTypeButtonAvailabilityCache.clear();
    requestAnimationFrame(() => updateProductTypeFilterBarAlignment(document));
    requestAnimationFrame(() => updateQuickFilterAvailability(document));
    requestAnimationFrame(() => {
        updateProductTypeFilterAvailability(document);
    });
});

const roCardImageWarmup = {
    observer: null,
    rootMargin: null
};

function roGetNetworkProfile() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const effectiveType = connection?.effectiveType || '';
    const saveData = Boolean(connection?.saveData);
    const isConstrained = saveData || effectiveType === 'slow-2g' || effectiveType === '2g';

    return {
        saveData,
        effectiveType,
        isConstrained
    };
}

function roGetCardWarmMargin() {
    const isMobile = window.matchMedia('(max-width: 999px)').matches;
    const { isConstrained } = roGetNetworkProfile();

    if (isConstrained) {
        return isMobile ? '900px 0px' : '1400px 0px';
    }

    return isMobile ? '1300px 0px' : '2200px 0px';
}

function roWarmImageElement(image, priority = 'auto') {
    if (!image) return;

    image.setAttribute('loading', 'eager');

    if (!image.getAttribute('fetchpriority')) {
        image.setAttribute('fetchpriority', priority);
    }

    image.decoding = 'async';

    if (typeof image.decode === 'function') {
        image.decode().catch(() => {
        });
    }
}

function roEnsureCardWarmObserver() {
    if (!('IntersectionObserver' in window)) return null;

    const desiredMargin = roGetCardWarmMargin();

    if (roCardImageWarmup.observer && roCardImageWarmup.rootMargin === desiredMargin) {
        return roCardImageWarmup.observer;
    }

    roCardImageWarmup.observer?.disconnect();
    roCardImageWarmup.rootMargin = desiredMargin;
    roCardImageWarmup.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            observer.unobserve(entry.target);
            roWarmImageElement(entry.target, 'auto');
        });
    }, {
        root: null,
        rootMargin: desiredMargin,
        threshold: 0.01
    });

    return roCardImageWarmup.observer;
}

window.lazyLoadCardImages = function (root = document) {
    roScheduleProductCardImageSizesSync(root);

    const lazyImages = root.querySelectorAll('.product-card img.product-image--primary[loading="lazy"]');

    if (!lazyImages.length) return;

    const observer = roEnsureCardWarmObserver();

    lazyImages.forEach((image) => {
        if (image.dataset.roWarmObserved === '1') return;

        image.dataset.roWarmObserved = '1';

        if (observer) {
            observer.observe(image);
        } else {
            roWarmImageElement(image, 'auto');
        }
    });
};

function roGetCardImageQualityTargetWidth(image) {
    const slot = image.closest(
        '.product-card__slide, .product-card__media, .product-card__url, .product-card__figure'
    );
    const rect = slot?.getBoundingClientRect?.() || image.getBoundingClientRect();

    return Math.round(Math.max(rect.width || 0, rect.height || 0));
}

function roSyncProductCardImageSizes(root = document) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const images = scope.querySelectorAll('.product-card img.product-image');

    if (!images.length) return;

    images.forEach((image) => {
        const qualityTargetWidth = roGetCardImageQualityTargetWidth(image);
        if (!qualityTargetWidth) return;

        const targetSize = `${Math.max(1, qualityTargetWidth)}px`;

        if (image.sizes !== targetSize) {
            image.sizes = targetSize;
        }
    });
}

function roScheduleProductCardImageSizesSync(root = document) {
    const run = () => roSyncProductCardImageSizes(root);

    requestAnimationFrame(run);
    setTimeout(run, 120);
    setTimeout(run, 320);
}

function roInitProductCardImageSizesSync() {
    roScheduleProductCardImageSizesSync(document);
}

if (document.readyState === 'complete') {
    roInitProductCardImageSizesSync();
} else {
    window.addEventListener('load', roInitProductCardImageSizesSync);
}

function roNormalizeUrlForCardKey(rawHref) {
    if (!rawHref) return '';

    try {
        const parsed = new URL(rawHref, window.location.origin);
        return `${parsed.pathname}${parsed.search}`;
    } catch (error) {
        return rawHref;
    }
}

function roGetProductCardKey(cardElement) {
    if (!cardElement) return '';

    const productLink = cardElement.querySelector('a[href*="/products/"]');
    if (productLink?.getAttribute('href')) {
        return roNormalizeUrlForCardKey(productLink.getAttribute('href'));
    }

    const handle = cardElement.getAttribute('handle');
    if (handle) {
        return `handle:${handle}`;
    }

    return '';
}

let roCardImageResizeTimer;
window.addEventListener('resize', () => {
    clearTimeout(roCardImageResizeTimer);
    roCardImageResizeTimer = setTimeout(() => {
        roScheduleProductCardImageSizesSync(document);
    }, 120);
}, { passive: true });

document.body.addEventListener('change', (event) => {
    const target = event.target;
    if (!target) return;

    if (target.name === 'desktop-layout' || target.name === 'mobile-items-per-row') {
        roScheduleProductCardImageSizesSync(document);
        window.lazyLoadCardImages?.(document);
    }
});

const PLP_IS_ANCHOR_THRESHOLD_PX = 48;
const PLP_IS_BOTTOM_THRESHOLD_PX = 240;
// Denylist only: keep every result-affecting param (q, type, options[...],
// filter.*, sort_by, constraint, view, custom flags). Ignore preview, page,
// section rendering, and known attribution/tracking keys.
const PLP_IS_IGNORED_QUERY_PARAMS = new Set([
    'page',
    'section_id',
    // Secret Sale invite redirects keep ?discount=CODE on the collection URL.
    // Pagination links omit it, so treating it as a listing constraint blocked infinite scroll.
    'discount',
    '_ab',
    '_fd',
    '_sc',
    'preview_theme_id',
    'pb',
    'key',
    'fbclid',
    'gclid',
    'gclsrc',
    'dclid',
    'msclkid',
    'ttclid',
    'twclid',
    'mc_cid',
    'mc_eid',
    '_hsenc',
    '_hsmi'
]);

function plpIsIgnoredQueryParam(key) {
    if (!key) return true;
    if (PLP_IS_IGNORED_QUERY_PARAMS.has(key)) return true;
    if (key.startsWith('utm_')) return true;
    return false;
}

function plpIsLog(event, data) {
    try {
        console.info('[plp-is]', event, data);
    } catch (error) {
        // Preview probe: path, page, listing hash, counts. Disable later for long-term production.
    }
}

function plpIsNavigationType() {
    const entry = performance.getEntriesByType?.('navigation')?.[0];
    return entry?.type || (performance.navigation && performance.navigation.type) || 'unknown';
}

function plpIsCardCount() {
    return document.querySelectorAll('.collection__results .product-card').length;
}

function plpIsPathname(href) {
    try {
        return new URL(href, window.location.origin).pathname;
    } catch (error) {
        return '';
    }
}

function plpIsListingHash(href) {
    const key = roListingKey(href);
    let hash = 5381;
    for (let index = 0; index < key.length; index += 1) {
        hash = ((hash << 5) + hash) ^ key.charCodeAt(index);
    }
    return (hash >>> 0).toString(16);
}

function plpIsContext(href = window.location.href) {
    return {
        path: plpIsPathname(href),
        page: roPageParam(href),
        listing: plpIsListingHash(href)
    };
}

function roCanonicalPageUrl(href) {
    try {
        const url = new URL(href, window.location.origin);
        url.searchParams.delete('section_id');
        url.hash = '';
        return `${url.pathname}${url.search}`;
    } catch (error) {
        return href || '';
    }
}

function roListingKey(href) {
    try {
        const url = new URL(href, window.location.origin);
        const pairs = [];

        url.searchParams.forEach((value, key) => {
            if (plpIsIgnoredQueryParam(key)) return;
            pairs.push([key, value]);
        });

        pairs.sort((a, b) => {
            if (a[0] === b[0]) return a[1].localeCompare(b[1]);
            return a[0].localeCompare(b[0]);
        });

        return `${url.pathname}?${pairs.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&')}`;
    } catch (error) {
        return href || '';
    }
}

function roPageParam(href) {
    try {
        return new URL(href, window.location.origin).searchParams.get('page') || '1';
    } catch (error) {
        return '1';
    }
}

if (!window.__plpIsDiagBound) {
    window.__plpIsDiagBound = true;
    plpIsLog('document-init', {
        ...plpIsContext(),
        nav: plpIsNavigationType(),
        cards: plpIsCardCount(),
        scrollY: Math.round(window.scrollY || 0)
    });
    window.addEventListener('pageshow', (event) => {
        plpIsLog('pageshow', {
            ...plpIsContext(),
            persisted: Boolean(event.persisted),
            cards: plpIsCardCount(),
            scrollY: Math.round(window.scrollY || 0)
        });
    });
}

var InfiniteScroll = class extends HTMLElement {
    constructor() {
        super();
        this.loading = false;
        this.hasError = false;
        this.loadToken = 0;
        this.loadObserver = null;
        this.prefetchObserver = null;
        this.cachedPage = null;
        this.prefetchUrl = '';
        this.prefetchPromise = null;
        this.prefetchController = null;
        this.loadController = null;
        this._onIntersection = this._onIntersection.bind(this);
        this._onPrefetchIntersection = this._onPrefetchIntersection.bind(this);
        this._onRetryClick = this._onRetryClick.bind(this);
        this._onFacetUpdate = this._onFacetUpdate.bind(this);
        this._onSecretSaleUnlock = this._onSecretSaleUnlock.bind(this);
    }

    connectedCallback() {
        if (!this.querySelector('.loading-spinner')) {
            this.innerHTML = `<div class="loading-spinner" hidden>
                        <div class="spinner"></div>
                      </div>
                      <div class="infinite-scroll__error" hidden role="status" aria-live="polite">
                        <p class="infinite-scroll__error-message"></p>
                        <button type="button" class="infinite-scroll__retry"></button>
                      </div>`;
        }

        this.loader = this.querySelector('.loading-spinner');
        this.errorElement = this.querySelector('.infinite-scroll__error');
        this.retryButton = this.querySelector('.infinite-scroll__retry');
        this.paginationElement = document.querySelector('.pagination-wrapper');
        this.nextPageLink = this._readNextPageLink();
        this.productContainer = document.querySelector('.collection__results .product-list');
        this.isMobile = window.matchMedia('(max-width: 999px)').matches;
        const { isConstrained, saveData, effectiveType } = roGetNetworkProfile();

        this.loadRootMargin = this.isMobile
            ? (isConstrained ? '1200px 0px' : '1700px 0px')
            : (isConstrained ? '1800px 0px' : '2600px 0px');

        this.prefetchRootMargin = this.isMobile
            ? (isConstrained ? '1800px 0px' : '3200px 0px')
            : (isConstrained ? '2400px 0px' : '4600px 0px');

        this.prefetchEnabled = !saveData && effectiveType !== 'slow-2g' && effectiveType !== '2g';

        window.lazyLoadCardImages?.(document);
        this.addEventListener('click', this._onRetryClick);
        document.addEventListener('facet:update', this._onFacetUpdate);
        window.addEventListener('smilodox:secret-sale:session', this._onSecretSaleUnlock);

        plpIsLog('is-connect', {
            ...plpIsContext(),
            nextPage: this.nextPageLink ? roPageParam(this.nextPageLink.href) : null,
            cards: plpIsCardCount(),
            scrollY: Math.round(window.scrollY || 0)
        });

        this._bindPageObservers();
    }

    disconnectedCallback() {
        this.loadToken += 1;
        this.loadObserver?.disconnect();
        this.prefetchObserver?.disconnect();
        this.removeEventListener('click', this._onRetryClick);
        document.removeEventListener('facet:update', this._onFacetUpdate);
        window.removeEventListener('smilodox:secret-sale:session', this._onSecretSaleUnlock);
        this._clearRequestState();
        this._releaseLoadUi();
    }

    /**
     * Secret Sale gate unlocks collection sections that were display:none.
     * Re-bind IntersectionObservers so pagination can load after first paint unlock.
     */
    _onSecretSaleUnlock(event) {
        const type = event?.detail?.type;
        if (type !== 'unlocked') return;
        this.paginationElement = document.querySelector('.pagination-wrapper');
        this.nextPageLink = this._readNextPageLink();
        this.productContainer = document.querySelector('.collection__results .product-list');
        this._bindPageObservers();
        window.requestAnimationFrame(() => {
            if (!this.nextPageLink || this.loading || this.hasError) return;
            this.loadNextPage();
        });
    }

    _bindPageObservers() {
        this.loadObserver?.disconnect();
        this.prefetchObserver?.disconnect();
        this.loadObserver = null;
        this.prefetchObserver = null;

        if (!this.nextPageLink || !this.productContainer || !this.paginationElement) return;

        this.loadObserver = new IntersectionObserver(
            this._onIntersection,
            {
                root: null,
                rootMargin: this.loadRootMargin,
                threshold: 0.01,
            }
        );

        if (this.prefetchEnabled) {
            this.prefetchObserver = new IntersectionObserver(
                this._onPrefetchIntersection,
                {
                    root: null,
                    rootMargin: this.prefetchRootMargin,
                    threshold: 0,
                }
            );
        }

        this.loadObserver.observe(this.paginationElement);
        this.prefetchObserver?.observe(this.paginationElement);
    }

    _getSectionId() {
        return document.querySelector('facets-form')?.getAttribute('section-id')
            || this.closest('.shopify-section')?.id?.replace(/^shopify-section-/, '')
            || null;
    }

    _readNextPageLink(root = this.paginationElement) {
        const link = root?.querySelector("a[rel='next']");
        if (!link?.href || link.classList.contains('is-disabled')) return null;

        const rawHref = link.getAttribute('href') || '';
        if (!rawHref || rawHref === '#collection') return null;

        try {
            const url = new URL(link.href, window.location.origin);
            if (url.searchParams.has('section_id')) {
                url.searchParams.delete('section_id');
                url.hash = '#collection';
                link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
            }
        } catch (error) {
            // Keep the original href if it cannot be normalized.
        }

        return link;
    }

    _sectionFetchUrl(canonicalUrl) {
        const url = new URL(canonicalUrl, window.location.origin);
        url.hash = '';
        const sectionId = this._getSectionId();
        if (sectionId) {
            url.searchParams.set('section_id', sectionId);
        }
        return url.toString();
    }

    _matchesCurrentListing(href) {
        return roListingKey(href) === roListingKey(window.location.href);
    }

    _canonicalNextUrl() {
        return this.nextPageLink ? roCanonicalPageUrl(this.nextPageLink.href) : '';
    }

    _onFacetUpdate() {
        this.loadToken += 1;
        this._clearRequestState();
        this._releaseLoadUi();
    }

    _onRetryClick(event) {
        const retry = event.target.closest('.infinite-scroll__retry, .infinite-scroll__error button');
        if (!retry || !this.contains(retry)) return;

        event.preventDefault();
        this.hasError = false;
        this._hideError();
        this.loadNextPage();
    }

    _onPrefetchIntersection(entries) {
        const entry = entries[0];
        if (!entry?.isIntersecting || !this.nextPageLink || this.loading || this.hasError) return;

        const canonicalUrl = this._canonicalNextUrl();
        this._prefetchPage(canonicalUrl);
    }

    _onIntersection(entries) {
        if (this.loading || this.hasError) return;

        const entry = entries[0];
        if (entry.isIntersecting && this.nextPageLink) {
            this.loadNextPage();
        }
    }

    _abortPrefetch() {
        this.prefetchController?.abort();
        this.prefetchController = null;
        this.prefetchUrl = '';
        this.prefetchPromise = null;
    }

    _clearRequestState() {
        this._abortPrefetch();
        this.loadController?.abort();
        this.loadController = null;
        this.cachedPage = null;
    }

    _releaseLoadUi() {
        this.loading = false;
        this.hasError = false;
        this._hideError();
        if (this.loader) this.loader.hidden = true;
        this.productContainer?.classList.remove('loading-more');
        this.productContainer?.classList.remove('is-appending');
        this.removeAttribute('aria-busy');
    }

    _parseValidSectionDocument(text) {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const results = doc.querySelector('.collection__results');
        const productList = results?.querySelector('.product-list');
        const pagination = doc.querySelector('.pagination-wrapper');

        if (!results || !productList || !pagination) {
            return null;
        }

        return doc;
    }

    _setCachedPage(canonicalUrl, text) {
        this.cachedPage = text ? { url: canonicalUrl, text } : null;
    }

    _takeCachedPage(canonicalUrl) {
        if (this.cachedPage?.url !== canonicalUrl) return null;
        const text = this.cachedPage.text;
        this.cachedPage = null;
        return text;
    }

    async _fetchPageText(canonicalUrl, { prefetch = false } = {}) {
        const controller = new AbortController();

        if (prefetch) {
            if (this.prefetchUrl !== canonicalUrl) {
                this._abortPrefetch();
            }
            this.prefetchController = controller;
            this.prefetchUrl = canonicalUrl;
        } else if (this.prefetchUrl && this.prefetchUrl !== canonicalUrl) {
            this._abortPrefetch();
            this.loadController = controller;
        } else {
            this.loadController = controller;
        }

        plpIsLog('page-request', {
            ...plpIsContext(canonicalUrl),
            prefetch
        });

        const response = await fetch(this._sectionFetchUrl(canonicalUrl), {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'text/html'
            },
            signal: controller.signal
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
    }

    _prefetchPage(canonicalUrl) {
        if (!this.prefetchEnabled || this.loading || this.hasError) return;
        if (!canonicalUrl || !this._matchesCurrentListing(canonicalUrl)) return;
        if (this.cachedPage?.url === canonicalUrl) return;
        if (this.prefetchUrl === canonicalUrl && this.prefetchPromise) return;

        if (this.cachedPage && this.cachedPage.url !== canonicalUrl) {
            this.cachedPage = null;
        }

        const request = this._fetchPageText(canonicalUrl, { prefetch: true })
            .then((text) => {
                if (this.prefetchUrl === canonicalUrl) {
                    this._setCachedPage(canonicalUrl, text);
                }
                return text;
            })
            .catch((error) => {
                if (error?.name === 'AbortError') return null;
                return null;
            })
            .finally(() => {
                if (this.prefetchUrl === canonicalUrl) {
                    this.prefetchPromise = null;
                    this.prefetchUrl = '';
                    this.prefetchController = null;
                }
            });

        this.prefetchPromise = request;
    }

    async _consumePageText(canonicalUrl) {
        const cached = this._takeCachedPage(canonicalUrl);
        if (cached) return cached;

        if (this.prefetchUrl === canonicalUrl && this.prefetchPromise) {
            const text = await this.prefetchPromise;
            return this._takeCachedPage(canonicalUrl) || text;
        }

        this._abortPrefetch();
        return this._fetchPageText(canonicalUrl, { prefetch: false });
    }

    _showError() {
        this.hasError = true;
        if (this.errorElement) {
            this.errorElement.hidden = false;
        }
        if (this.loader) {
            this.loader.hidden = true;
        }
    }

    _hideError() {
        if (this.errorElement) {
            this.errorElement.hidden = true;
        }
    }

    _captureScrollAnchor() {
        if (!this.productContainer) return null;

        const cards = Array.from(this.productContainer.querySelectorAll('.product-card'));
        for (let index = 0; index < cards.length; index += 1) {
            const card = cards[index];
            const rect = card.getBoundingClientRect();
            if (rect.bottom > 0 && rect.top < window.innerHeight) {
                return {
                    card,
                    offset: rect.top,
                    index,
                    key: roGetProductCardKey(card)
                };
            }
        }

        return null;
    }

    _measureAnchorState(anchor) {
        const list = this.productContainer;
        const listHeight = list ? Math.round(list.getBoundingClientRect().height) : 0;
        const columns = list
            ? (getComputedStyle(list).gridTemplateColumns || '').split(' ').filter(Boolean).length
            : 0;
        const scrollY = Math.round(window.scrollY || 0);
        const maxScroll = Math.round(Math.max(0, document.documentElement.scrollHeight - window.innerHeight));

        return {
            key: anchor?.key || (anchor?.card ? roGetProductCardKey(anchor.card) : null),
            index: Number.isInteger(anchor?.index) ? anchor.index : -1,
            scrollY,
            maxScroll,
            fromBottom: maxScroll - scrollY,
            nearBottom: (maxScroll - scrollY) <= PLP_IS_BOTTOM_THRESHOLD_PX,
            anchorTop: anchor?.card?.isConnected ? Math.round(anchor.card.getBoundingClientRect().top) : null,
            listHeight,
            columns
        };
    }

    _loaderVisibility() {
        const pagination = this.paginationElement?.getBoundingClientRect();
        const loader = this.getBoundingClientRect();

        return {
            paginationTop: pagination ? Math.round(pagination.top) : null,
            paginationFromViewport: pagination ? Math.round(pagination.top - window.innerHeight) : null,
            paginationIntersecting: pagination
                ? pagination.top < window.innerHeight && pagination.bottom > 0
                : null,
            loaderTop: Math.round(loader.top),
            loaderFromViewport: Math.round(loader.top - window.innerHeight),
            loaderIntersecting: loader.top < window.innerHeight && loader.bottom > 0
        };
    }

    _restoreScrollAnchor(anchor, beforeState) {
        if (window.__plpIsDisableAnchor) {
            plpIsLog('anchor-disabled', {
                before: beforeState,
                after: this._measureAnchorState(anchor),
                loader: this._loaderVisibility()
            });
            return;
        }
        if (!anchor?.card?.isConnected) return;

        const afterState = this._measureAnchorState(anchor);
        const delta = (afterState.anchorTop ?? 0) - (anchor.offset ?? 0);

        if (Math.abs(delta) < PLP_IS_ANCHOR_THRESHOLD_PX) {
            plpIsLog('anchor-hold', {
                delta: Math.round(delta),
                before: beforeState,
                after: afterState,
                loader: this._loaderVisibility()
            });
            return;
        }

        window.scrollBy(0, delta);
        plpIsLog('anchor-restore', {
            delta: Math.round(delta),
            before: beforeState,
            after: this._measureAnchorState(anchor),
            loader: this._loaderVisibility()
        });
    }

    async loadNextPage() {
        if (!this.nextPageLink || this.loading || !this.productContainer) return;

        const canonicalUrl = this._canonicalNextUrl();
        if (!canonicalUrl) return;
        if (!this._matchesCurrentListing(canonicalUrl)) {
            plpIsLog('stale-ignored', plpIsContext(canonicalUrl));
            return;
        }

        const token = ++this.loadToken;
        this.loading = true;
        this.hasError = false;
        this._hideError();
        if (this.loader) this.loader.hidden = false;
        this.productContainer.classList.add('loading-more');
        this.setAttribute('aria-busy', 'true');

        plpIsLog('load-start', {
            ...plpIsContext(canonicalUrl),
            cards: plpIsCardCount(),
            scrollY: Math.round(window.scrollY || 0)
        });

        try {
            const text = await this._consumePageText(canonicalUrl);
            if (token !== this.loadToken || !this.isConnected) return;
            if (!text) throw new Error('empty-response');
            if (!this._matchesCurrentListing(canonicalUrl)) {
                plpIsLog('stale-ignored', plpIsContext(canonicalUrl));
                return;
            }

            this.cachedPage = null;

            const doc = this._parseValidSectionDocument(text);
            if (!doc) throw new Error('invalid-section');

            const incomingNext = this._readNextPageLink(doc.querySelector('.pagination-wrapper'));
            const incomingNextUrl = incomingNext ? roCanonicalPageUrl(incomingNext.href) : '';
            if (incomingNextUrl === canonicalUrl) {
                throw new Error('stuck-pagination');
            }

            const newProducts = doc.querySelectorAll('.collection__results .product-card');
            const cardsBefore = plpIsCardCount();
            const scrollBefore = window.scrollY || 0;
            const anchor = this._captureScrollAnchor();
            const beforeState = this._measureAnchorState(anchor);
            plpIsLog('anchor-before', beforeState);

            if (!window.__plpIsDisableAppendingClass) {
                this.productContainer.classList.add('is-appending');
            }

            if (newProducts.length > 0) {
                this._appendProducts(Array.from(newProducts));
            }
            plpIsLog('anchor-after-insert', this._measureAnchorState(anchor));

            this._replacePagination(doc);
            plpIsLog('anchor-after-pagination', this._measureAnchorState(anchor));

            this._restoreScrollAnchor(anchor, beforeState);
            this.productContainer?.classList.remove('is-appending');
            plpIsLog('anchor-after-restore', {
                ...this._measureAnchorState(anchor),
                loader: this._loaderVisibility(),
                offsetDelta: anchor?.card?.isConnected
                    ? Math.round(anchor.card.getBoundingClientRect().top - (anchor.offset ?? 0))
                    : null
            });

            await new Promise((resolve) => requestAnimationFrame(resolve));
            if (token !== this.loadToken || !this.isConnected) return;

            plpIsLog('anchor-raf', {
                ...this._measureAnchorState(anchor),
                loader: this._loaderVisibility()
            });
            this._observePagination();

            plpIsLog('load-complete', {
                ...plpIsContext(canonicalUrl),
                bytes: text.length,
                cardsBefore,
                cardsAfter: plpIsCardCount(),
                appended: newProducts.length,
                scrollBefore: Math.round(scrollBefore),
                scrollAfter: Math.round(window.scrollY || 0)
            });
        } catch (error) {
            this.productContainer?.classList.remove('is-appending');
            if (error?.name === 'AbortError' || token !== this.loadToken || !this.isConnected) return;
            this._showError();
            plpIsLog('load-error', {
                ...plpIsContext(canonicalUrl),
                message: String(error?.message || error)
            });
        } finally {
            if (token === this.loadToken) {
                this.loading = false;
                this.loadController = null;
                if (this.loader && !this.hasError) this.loader.hidden = true;
                this.productContainer?.classList.remove('loading-more');
                this.removeAttribute('aria-busy');
            }
        }
    }

    _appendProducts(productsArray) {
        const fragment = document.createDocumentFragment();
        const appendedProducts = [];
        const existingCardKeys = new Set();
        const existingCount = this.productContainer.querySelectorAll('.product-card').length;

        this.productContainer.querySelectorAll('.product-card').forEach((existingCard) => {
            const key = roGetProductCardKey(existingCard);
            if (key) {
                existingCardKeys.add(key);
            }
        });

        productsArray.forEach((product) => {
            const incomingKey = roGetProductCardKey(product);
            if (incomingKey && existingCardKeys.has(incomingKey)) {
                return;
            }

            const clonedProduct = product.cloneNode(true);
            clonedProduct.setAttribute('data-plp-appended', '');
            clonedProduct.dataset.cardPosition = String(existingCount + appendedProducts.length + 1);
            if (incomingKey) {
                existingCardKeys.add(incomingKey);
            }
            appendedProducts.push(clonedProduct);
            fragment.appendChild(clonedProduct);
        });

        this.productContainer.appendChild(fragment);
        appendedProducts.forEach((product) => {
            roSyncProductCardImageSizes(product);
        });
        this._prioritizeAppendedProducts(appendedProducts);
    }

    _prioritizeAppendedProducts(products) {
        products.slice(0, 2).forEach((product, index) => {
            const image = product.querySelector('img.product-image--primary, img.product-image');
            if (!image) return;

            roWarmImageElement(image, index === 0 ? 'high' : 'auto');
        });
    }

    _replacePagination(doc) {
        const newPagination = doc.querySelector('.pagination-wrapper');
        if (!newPagination || !this.paginationElement) return;

        this.loadObserver?.disconnect();
        this.prefetchObserver?.disconnect();
        this.paginationElement.innerHTML = newPagination.innerHTML;
        this.nextPageLink = this._readNextPageLink();

        if (!this.nextPageLink && this.loader) {
            this.loader.hidden = true;
        }
    }

    _observePagination() {
        if (!this.nextPageLink || !this.paginationElement) return;

        this.loadObserver?.disconnect();
        this.prefetchObserver?.disconnect();
        this.loadObserver?.observe(this.paginationElement);
        this.prefetchObserver?.observe(this.paginationElement);
    }
};

if (!window.customElements.get("infinite-scroll")) {
    window.customElements.define("infinite-scroll", InfiniteScroll);
}


(function () {
    const drawerSelector = '#facets-drawer';
    let blockBodyScroll = false;

    document.addEventListener('focusin', (e) => {
        if (e.target.matches('.price-range input')) {
            blockBodyScroll = true;
        }
    });

    document.addEventListener('focusout', (e) => {
        if (e.target.matches('.price-range input')) {
            blockBodyScroll = false;
        }
    });

    document.addEventListener(
        'touchmove',
        (e) => {
            if (!blockBodyScroll) return;

            const drawer = e.target.closest(drawerSelector);
            if (!drawer) {
                e.preventDefault();
                return;
            }

            const scrollTop = drawer.scrollTop;
            const scrollHeight = drawer.scrollHeight;
            const offsetHeight = drawer.offsetHeight;

            if (
                (scrollTop === 0 && e.touches[0].clientY > 0) ||
                (scrollTop + offsetHeight >= scrollHeight && e.touches[0].clientY < 0)
            ) {
                e.preventDefault();
            }

        },
        { passive: false }
    );
})();


function updateFilterCount(drawer) {
    if (!drawer) return;

    const applyButtons = document.querySelectorAll('.filter-apply-btn');
    if (!applyButtons.length) return;

    let count = Array.from(
        drawer.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked')
    ).filter(input => input.name !== 'sort_by').length;

    const min = drawer.querySelector('input[name*="min"]');
    const max = drawer.querySelector('input[name*="max"]');

    if (
        (min && min.value.trim() !== '') ||
        (max && max.value.trim() !== '')
    ) {
        count += 1;
    }

    applyButtons.forEach((submitBtn) => {
        const buttonContent = submitBtn.querySelector('button-content');
        if (!buttonContent) return;

        if (!buttonContent.dataset.baseText) {
            buttonContent.dataset.baseText =
                buttonContent.textContent.replace(/\s*\(\d+\)/, '');

            buttonContent.dataset.baseUpText =
                buttonContent.getAttribute('up-text')?.replace(/\s*\(\d+\)/, '') ||
                buttonContent.dataset.baseText;
        }

        const baseText = buttonContent.dataset.baseText;
        const baseUpText = buttonContent.dataset.baseUpText;

        if (count > 0) {
            buttonContent.textContent = `${baseText} (${count})`;
            buttonContent.setAttribute('up-text', `${baseUpText} (${count})`);
        } else {
            buttonContent.textContent = baseText;
            buttonContent.setAttribute('up-text', baseUpText);
        }
    });
}


document.addEventListener('input', e => {
    const drawer = e.target.closest('.drawer--facets');
    if (drawer) updateFilterCount(drawer);
});

document.addEventListener('change', e => {
    const drawer = e.target.closest('.drawer--facets');
    if (drawer) updateFilterCount(drawer);
});

/* discount filter bar */
document.body.addEventListener("click", (event) => {
    const btn = event.target.closest(".discount-filter__button");
    if (!btn) return;
    const param = btn.dataset.param;
    const value = btn.dataset.value;
    const input = document.querySelector(
        `facets-form input[name="${param}"][value="${value}"]`
    );
    if (!input) return;

    input.checked = !input.checked;
    btn.dataset.active = input.checked ? "true" : "false";

    const facetsForm = input.closest("facets-form");
    const submitsOnChange = facetsForm.hasAttribute("update-on-change");

    facetsForm.dispatchEvent(new CustomEvent("change", {
        bubbles: true,
        detail: {
            skipPrefetch: !submitsOnChange
        }
    }));

    if (submitsOnChange) return;

    if (HTMLFormElement.prototype.requestSubmit) {
        facetsForm.querySelector("form").requestSubmit();
    } else {
        facetsForm.querySelector("form").dispatchEvent(new Event("submit", { bubbles: true }));
    }
});
/* discount filter bar end */
